import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from "../../../../../environments/environment";
import {SecurityService} from "../../security.service";
import {UtilityService} from "../../utility.service";
import {CommonResponse} from "../../../response/common.response";


@Injectable({
    providedIn: 'root'
})
export class ApiResumengraficoRepository {
    /**
     * Contiene la ruta de conexión a servicios publicos
     */
    API_URI = environment.API_URI;

    // tslint:disable-next-line:max-line-length
    constructor(private http: HttpClient, private securityService: SecurityService, private utilityService: UtilityService) {
    }

    // @ts-ignore
    public async getTotalesDashboard(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getTotalesDashboard', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getGraficoTopCliente(objEnvio: any): Promise<CommonResponse> {
        try {
                const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getGraficoTopClientesByOperador', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }


    // @ts-ignore
    public async getGraficoOperacionesOperador(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getGraficoOperacionesByOperador', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }


    // @ts-ignore
    public async getClasificacionClientesByOperador(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getClasificacionClientesByOperador', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getDetalleClientesOtrosVisor(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getDetalleClientesOtrosVisor', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getEstadoCuentaActualOperador(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getEstadoCuentaActualOperador').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerGraficoProductosMovidosByFiltros(params: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'producto/obtenerGraficoProductosMovidosByFiltros', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerGraficoTopClientesByFiltros(params: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'cliente/obtenerGraficoTopClientesByFiltros', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerGraficoMovimientosPorTipoContenedorByFiltros(params: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'booking/obtenerGraficoMovimientosPorTipoContenedorByFiltros', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerGraficoMovimientosPorSucursalByFiltros(params: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'local/obtenerGraficoMovimientosPorSucursalByFiltros', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getDamKpiTotales(params: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getDamKpiTotales', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getDamKpiGraficoPie(params: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getDamKpiGraficoPie', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getDamKpiGraficoBarCliente(params: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getDamKpiGraficoBarCliente', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getDamKpiDetalle(params: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getDamKpiDetalle', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerGraficoKpiRegularizacionByFiltros(params: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'bookingdam/obtenerGraficoKpiRegularizacionByFiltros', params).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getGraficoMovimientosPorTipoContenedor(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getGraficoMovimientosPorTipoContenedor', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getGraficoMovimientosPorTipoEmbarque(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getGraficoMovimientosPorTipoEmbarque', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerReporteStatusDocumentario(params: any): Promise<CommonResponse> {
        const operador_id = params.operador_id;
        const fechaInicio = params.fechaInicio;
        const fechaFinal = params.fechaFinal;
        const pagina = params.pagina;
        const registros = params.registros;
        const cliente_id = params.cliente_id;
        const nave_id = params.nave_id;
        const retornarDocumentos = params.retornarDocumentos;
        const linea_id = params.linea_id;
        const tipofiltro = params.tipofiltro;
        const numerosemana = params.numerosemana;
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'reporteria/reporteBookingPorOperador/' + operador_id + '/' + fechaInicio + '/' + fechaFinal + '/' + pagina + '/' + registros + '/' + cliente_id
                + '/' + nave_id + '/' + retornarDocumentos + '/' + linea_id + '/' + tipofiltro + '/' + numerosemana).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    // @ts-ignore
    public async obtenerPendientesParaDocumentacion(operadorId: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'bookingdam/obtenerPendientesParaDocumentacion/' + operadorId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async obtenerFacturasPendientesRegularizacion(operadorId: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'booking/obtenerFacturasPendientesRegularizacion/' + operadorId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

}
